import Vue from "vue";
import Vuetify, { VTextField, VChip, VDataTable, VDialog, VContainer, VProgressCircular, VLayout } from "vuetify/lib";

Vue.use(Vuetify, {
    components: {
        VTextField,
        VChip,
        VDataTable,
        VDialog,
        VContainer,
        VProgressCircular,
        VLayout
    }
});

export default new Vuetify({
    theme: {
        primary: "#090097",
        secondary: "#42b2ea",
        success: "#57c062",
        info: "#ffaa2c",
        error: "#dc2157",
        new: "#975500",
        darkgrey: "#808080",
        view: "#dfaf4c",
        edit: "#57c062",
        danger: "#dc2157"
    },
    icons: {
        iconfont: "mdi"
    }
});
